import { FC, createContext, useContext } from 'react';
import { useDispatch } from 'react-redux';

import { setModal } from 'modules/_shared/redux/modalActions';

import { aiQuotaExceededModalInitValue } from '../constants/aiQuotaExceededModalInitValue';
import { AiQuotaExceededModalContextType } from '../types/AiQuotaExceededModalContextType';

const AiQuotaExceededModalContext =
  createContext<AiQuotaExceededModalContextType>(aiQuotaExceededModalInitValue);

type ProviderProps = {
  children: React.ReactNode;
  used: number;
  limit: number;
  tier: string;
};

export const AiQuotaExceededModalProvider: FC<ProviderProps> = ({
  children,
  used,
  limit,
  tier,
}) => {
  const dispatch = useDispatch();

  const handleCloseModal = () => {
    dispatch(setModal(null));
  };

  const handleUpgrade = () => {
    window.open('mailto:info@sttok.com?subject=Upgrade%20AI%20plan', '_blank');
    handleCloseModal();
  };

  return (
    <AiQuotaExceededModalContext.Provider
      value={{
        data: { used, limit, tier },
        actions: { handleCloseModal, handleUpgrade },
      }}
    >
      {children}
    </AiQuotaExceededModalContext.Provider>
  );
};

export const useAiQuotaExceededModal = () =>
  useContext(AiQuotaExceededModalContext);
